import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/auth-context";
import { TermsModal } from "./terms-modal";
import { IAuthData } from "../auth/model/dto";
import { useLocation } from "react-router-dom";
import './terms-checker.css';

export const TermsChecker: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authData, isAuthenticated, termsAccepted, setAuthData } = useAuth();
  const [showTermsModal, setShowTermsModal] = useState(false);
  const location = useLocation();

  // Check auth status and terms status whenever auth changes or location changes
  useEffect(() => {
    // Show terms modal if user is authenticated but hasn't accepted terms
    if (isAuthenticated && !termsAccepted) {
      // Short delay to ensure rendering happens after navigation
      const timer = setTimeout(() => {
        setShowTermsModal(true);
      }, 100);
      
      return () => clearTimeout(timer);
    } else {
      setShowTermsModal(false);
    }
  }, [isAuthenticated, termsAccepted, location.pathname]);

  const handleTermsAccepted = () => {
    // Update the local auth data to reflect terms acceptance
    const updatedAuthData: IAuthData = {
      ...authData,
      terms: true
    };
    setAuthData(updatedAuthData);
    setShowTermsModal(false);
  };

  return (
    <div className={`app-container ${isAuthenticated && !termsAccepted ? 'terms-pending' : ''}`}>
      {children}
      <TermsModal 
        show={showTermsModal} 
        onAccept={handleTermsAccepted} 
      />
    </div>
  );
}; 